import React, { useEffect, useState } from 'react';
import { Card, Typography, Grid, Box, Accordion, AccordionSummary, AccordionDetails, useTheme, FormControlLabel, Switch, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, IconButton, Tooltip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DescriptionIcon from '@mui/icons-material/Description';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Progetti from './Progetti';
const moment = require('moment');

const SchedaCard = () => {
    const [schede, setSchede] = useState([]);
    const [showExpired, setShowExpired] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [sites, setSites] = useState([]);
    const [contracts, setContracts] = useState([]);
    const [newScheda, setNewScheda] = useState({
        numeroscheda: '',
        codicecontratto: '',
        idsito_fk: ''
    });
    const theme = useTheme();

    const fetchSchede = () => {
        const token = localStorage.getItem('token');
        fetch('/papi2/projects/getSchede', {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401 || response.status === 403) {
                        localStorage.removeItem('token');
                        window.location.href = '/login';
                    }
                    throw new Error('Errore nel caricamento delle schede');
                }
                return response.json();
            })
            .then((data) => {
                if (Array.isArray(data)) {
                    setSchede(data);
                } else {
                    console.error('API non ha restituito un array:', data);
                    setSchede([]);
                }
            })
            .catch((error) => console.error('Errore nel recupero dei dati:', error));
    };

    useEffect(() => {
        fetchSchede();
    }, []);

    const fetchInitialData = async () => {
        const token = localStorage.getItem('token');
        try {
            const [sitesRes, contractsRes] = await Promise.all([
                fetch('/papi2/sites', { headers: { 'Authorization': `Bearer ${token}` } }),
                fetch('/papi2/contracts', { headers: { 'Authorization': `Bearer ${token}` } })
            ]);
            if (sitesRes.ok) setSites(await sitesRes.json());
            if (contractsRes.ok) setContracts(await contractsRes.json());
        } catch (err) {
            console.error("Errore nel caricamento dei dati iniziali:", err);
        }
    };

    const handleOpenModal = () => {
        fetchInitialData();
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setNewScheda({ numeroscheda: '', codicecontratto: '', idsito_fk: '' });
    };

    const handleSaveScheda = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch('/papi2/projects/addScheda', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newScheda)
            });
            if (response.ok) {
                handleCloseModal();
                fetchSchede();
            } else {
                alert("Errore durante il salvataggio della scheda");
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleDeleteScheda = async (id) => {
        if (!window.confirm("Sei sicuro di voler eliminare questa scheda?")) return;
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`/papi2/projects/deleteScheda/${id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (response.ok) {
                fetchSchede();
            } else {
                const msg = await response.text();
                alert(`Errore: ${msg}`);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const filteredSchede = Array.isArray(schede) ? schede.filter(scheda => {
        if (showExpired) return true;
        if (!scheda.data_scadenza_contratto) return true;
        return moment(scheda.data_scadenza_contratto).isSameOrAfter(moment(), 'day');
    }) : [];

    return (
        <Box sx={{ p: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={handleOpenModal}
                    sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 700 }}
                >
                    Nuova Scheda
                </Button>
                <Box sx={{ bgcolor: 'background.paper', p: 1, borderRadius: 2, boxShadow: 1, width: 'fit-content' }}>
                    <FormControlLabel
                        control={<Switch checked={showExpired} onChange={(e) => setShowExpired(e.target.checked)} color="warning" />}
                        label={<Typography fontWeight={600} color="text.secondary">Mostra contratti scaduti</Typography>}
                    />
                </Box>
            </Box>

            <Grid container spacing={3} justifyContent="center">
                {filteredSchede.map((scheda, index) => (
                    <Grid item key={index} xs={12}>
                        <Card
                            elevation={3}
                            sx={{
                                borderRadius: 3,
                                overflow: 'hidden',
                                background: 'rgba(255, 255, 255, 0.95)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(0,0,0,0.05)',
                                transition: 'transform 0.2s',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 12px 24px rgba(0,0,0,0.1)',
                                }
                            }}
                        >
                            <Accordion
                                disableGutters
                                elevation={0}
                                sx={{
                                    '&:before': { display: 'none' },
                                    background: 'transparent'
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon sx={{ color: theme.palette.primary.main }} />}
                                    sx={{
                                        borderBottom: '1px solid rgba(0,0,0,0.05)',
                                        '& .MuiAccordionSummary-content': { margin: '16px 0' }
                                    }}
                                >
                                    <Grid container spacing={2} alignItems="center">
                                        {/* Numero Scheda */}
                                        <Grid item xs={12} md={2}>
                                            <Box display="flex" alignItems="center">
                                                <Box sx={{
                                                    p: 1.5,
                                                    borderRadius: 2,
                                                    bgcolor: 'primary.light',
                                                    color: 'white',
                                                    mr: 2,
                                                    display: 'flex'
                                                }}>
                                                    <AssignmentIcon fontSize="medium" />
                                                </Box>
                                                <Box>
                                                    <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase" letterSpacing={1}>
                                                        Scheda
                                                    </Typography>
                                                    <Typography variant="h6" color="primary.dark" fontWeight={700}>
                                                        #{scheda.numeroscheda}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>

                                        {/* Contratto e Cliente */}
                                        <Grid item xs={12} md={6}>
                                            <Box display="flex" alignItems="center">
                                                <DescriptionIcon sx={{ color: 'secondary.main', mr: 2, fontSize: 28 }} />
                                                <Box>
                                                    <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase" letterSpacing={1}>
                                                        Contratto
                                                    </Typography>
                                                    <Typography variant="h6" color="text.primary" fontWeight={600} lineHeight={1.2}>
                                                        {scheda.oggetto_contratto}
                                                    </Typography>
                                                    {scheda.nomecliente && (
                                                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                                                            {scheda.nomecliente}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Grid>

                                        {/* Sito */}
                                        <Grid item xs={12} md={3}>
                                            <Box display="flex" alignItems="center" justifyContent={{ md: 'flex-end' }}>
                                                <Box sx={{ textAlign: { md: 'right' }, mr: 2 }}>
                                                    <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase" letterSpacing={1}>
                                                        Sito di Riferimento
                                                    </Typography>
                                                    <Typography variant="h6" color="error.main" fontWeight={700}>
                                                        {scheda.nomesito}
                                                    </Typography>
                                                </Box>
                                                <LocationOnIcon color="error" fontSize="large" />
                                            </Box>
                                        </Grid>

                                        {/* Azioni */}
                                        <Grid item xs={12} md={1}>
                                            <Box display="flex" justifyContent="flex-end">
                                                {(!scheda.num_progetti || scheda.num_progetti === 0) && (
                                                    <Tooltip title="Elimina Scheda">
                                                        <IconButton
                                                            color="error"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteScheda(scheda.idscheda);
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>

                                <AccordionDetails sx={{ p: 0, bgcolor: 'background.default' }}>
                                    <Progetti idScheda={scheda.idscheda} idCliente={scheda.idcliente} />
                                </AccordionDetails>
                            </Accordion>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Modal Nuova Scheda */}
            <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="sm">
                <DialogTitle sx={{ fontWeight: 700 }}>Aggiungi Nuova Scheda</DialogTitle>
                <DialogContent>
                    <Box component="form" sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <TextField
                            fullWidth
                            label="Numero Scheda"
                            value={newScheda.numeroscheda}
                            onChange={(e) => setNewScheda({ ...newScheda, numeroscheda: e.target.value })}
                        />
                        <TextField
                            select
                            fullWidth
                            label="Contratto"
                            value={newScheda.codicecontratto}
                            onChange={(e) => setNewScheda({ ...newScheda, codicecontratto: e.target.value })}
                        >
                            {contracts.map((contract) => (
                                <MenuItem key={contract.idcontratto} value={contract.idcontratto}>
                                    {contract.numero_contratto} - {contract.oggetto_contratto} ({contract.nome_cliente})
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            select
                            fullWidth
                            label="Sito di Riferimento"
                            value={newScheda.idsito_fk}
                            onChange={(e) => setNewScheda({ ...newScheda, idsito_fk: e.target.value })}
                        >
                            {sites.map((site) => (
                                <MenuItem key={site.idsito} value={site.idsito}>
                                    {site.nomesito} ({site.nomecomune})
                                </MenuItem>
                            ))}
                        </TextField>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 3 }}>
                    <Button onClick={handleCloseModal} color="inherit">Annulla</Button>
                    <Button onClick={handleSaveScheda} variant="contained" color="primary">Salva Scheda</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default SchedaCard;
